import { StyleSheet, Platform } from 'react-native';
import { theme } from '../../styles/theme';

export const createMessageStyles = (screenWidth, isCollapsed = false) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0,
    height: '100%',
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    ...(Platform.OS === 'web' && screenWidth <= 900 ? {
      display: 'flex',
      flexDirection: 'column',
    } : {}),
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.colors.primary,
    fontFamily: theme.fonts.header.fontFamily,
  },
  filterButton: {
    marginLeft: 'auto',
  },
  contentContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: screenWidth > 900 ? '100%' : 900,
    alignSelf: 'center',
    width: '100%',
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    marginTop: 0,
    paddingTop: 0,
  },
  mainSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: Platform.OS === 'web' ? 
      (screenWidth <= 900 ? '100%' : '70%') : 
      '100%',
    alignSelf: screenWidth <= 900 ? 'stretch' : 'flex-start',
    width: screenWidth <= 900 ? '100%' : 'auto',
    height: '100%',
    marginTop: 0,
    paddingTop: 0,
  },
  conversationListContainer: {
    width: screenWidth <= 900 ? '100%' : '30%',
    maxWidth: screenWidth < 900 ? '' : 600,
    backgroundColor: theme.colors.surfaceContrast,
    overflow: 'auto',
  },
  conversationItem: {
    padding: 16,
    maxWidth: screenWidth < 900 ? '' : 600,
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
    flexDirection: 'row',
    alignItems: 'center',
  },
  conversationProfilePhoto: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  conversationProfilePhotoFallback: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
    backgroundColor: theme.colors.background,
    justifyContent: 'center',
    alignItems: 'center',
  },
  conversationContent: {
    flex: 1,
  },
  selectedConversation: {
    backgroundColor: theme.colors.primary + '20',
    borderLeftWidth: 3,
    borderLeftColor: theme.colors.primary,
  },
  conversationName: {
    fontSize: 16,
    fontFamily: theme.fonts.header.fontFamily,
    flex: 1,
  },
  messageSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    paddingHorizontal: 5,
    backgroundColor: theme.colors.surface,
    paddingBottom: 0,
    position: 'relative',
  },
  messageHeader: {
    padding: 12,
    backgroundColor: theme.colors.surfaceContrast,
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1,
    ...(Platform.OS === 'web' && screenWidth <= 900 ? {
      position: 'sticky',
      top: 0,
    } : {}),
  },
  profilePhoto: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  messageHeaderName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colors.text,
    fontFamily: theme.fonts.header.fontFamily,
  },
  // Mobile header profile photo styles
  mobileProfilePhotoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  mobileProfilePhoto: {
    width: 60,
    height: 60,
    borderRadius: 30,
  },
  mobileProfilePhotoFallback: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: theme.colors.background,
    justifyContent: 'center',
    alignItems: 'center',
  },
  messagesContainer: {
    flex: 1,
    overflow: 'auto',
    width: '100%',
    ...(Platform.OS === 'web' && screenWidth <= 900 ? {
      WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
    } : {}),
  },
  messageList: {
    width: '100%',
    paddingBottom: 16,
  },
  fullWidthMessage: {
    width: '100%',
    alignSelf: 'center',
    paddingHorizontal: 8,
  },
  textInput: {
    flex: 1,
    backgroundColor: theme.colors.background,
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginRight: 8,
    marginLeft: 8,
    fontSize: 16,
    color: theme.colors.text,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  sendButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  sendButtonMobile: {
    width: 32,
    height: 32,
    borderRadius: 16,
    paddingHorizontal: 0,
    paddingVertical: 0,
    marginHorizontal: 0,
    minWidth: 0,
  },
  sendButtonActive: {
    backgroundColor: theme.colors.primary,
  },
  sendButtonInactive: {
    backgroundColor: theme.colors.border,
  },
  webInput: {
    flex: 1,
    backgroundColor: theme.colors.surface,
    borderRadius: 20,
    paddingHorizontal: 20,
    paddingVertical: 8,
    marginHorizontal: 8,
    fontSize: 18,
    color: theme.colors.text,
    fontFamily: theme.fonts.regular.fontFamily,
    maxHeight: 120,
    minHeight: 20,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  input: {
    flex: 1,
    backgroundColor: theme.colors.surface,
    borderRadius: 20,
    paddingHorizontal: 20,
    paddingVertical: 8,
    marginHorizontal: 8,
    fontSize: 18,
    color: theme.colors.text,
    fontFamily: theme.fonts.regular.fontFamily,
    borderWidth: 1,
    borderColor: theme.colors.border,
    minHeight: 20,
  },
  inputSection: {
    width: '100%',
    padding: 8,
    backgroundColor: theme.colors.surfaceContrast,
    zIndex: 10,
    ...(Platform.OS === 'web' && screenWidth <= 900 ? {
      position: 'relative', // Changed from fixed to relative
      bottom: 0,
      left: 0,
      right: 0,
      paddingTop: 8,
      paddingBottom: 8,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: -1 },
      shadowOpacity: 0.1,
      shadowRadius: 3,
      elevation: 3,
    } : {}),
  },
  inputContainerOuter: {
    width: '100%',
    flexDirection: 'column',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  attachButtonContainer: {
    marginRight: 8,
  },
  attachButton: {
    padding: 8,
    backgroundColor: theme.colors.surfaceContrast,
    borderRadius: 20,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputInnerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.surfaceContrast,
    borderRadius: 20,
    marginRight: 0,
  },
  dropdownMenu: {
    position: 'absolute',
    bottom: '100%',
    left: 0,
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginBottom: 8,
    minWidth: 150,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  dropdownItem: {
    padding: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  dropdownText: {
    color: theme.colors.text,
    fontSize: 14,
    marginLeft: 8,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  messageCard: {
    // marginVertical: 4,
    maxWidth: screenWidth > 900 ? '40%' : '75%',
    borderRadius: 12,
    overflow: 'hidden',
  },
  messageContent: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  sentMessage: {
    alignSelf: 'flex-end',
    backgroundColor: theme.colors.primary,
  },
  receivedMessage: {
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.receivedMessage,
  },
  messageText: {
    fontSize: 20,
    lineHeight: 20,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  sentMessageContainer: {
    alignItems: 'flex-end',
    // marginBottom: 4,
  },
  receivedMessageContainer: {
    alignItems: 'flex-start',
    marginBottom: 4,
  },
  sentMessageText: {
    color: theme.colors.whiteText,
  },
  receivedMessageText: {
    color: theme.colors.text,
  },
  // Timestamp styles
  messageTimestampContainer: {
    paddingHorizontal: 4,
    marginBottom: 2,
    marginTop: 8,
  },
  sentMessageTimestamp: {
    alignSelf: 'flex-end',
    marginRight: 4,
    marginBottom: 2,
  },
  receivedMessageTimestamp: {
    alignSelf: 'flex-start',
    marginLeft: 4,
    marginBottom: 2,
  },
  messageTimestampText: {
    fontSize: 12,
    color: theme.colors.placeholder,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  searchContainer: {
    padding: 16,
    backgroundColor: theme.colors.surfaceContrast,
  },
  searchInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.surface,
    borderRadius: 20,
    paddingHorizontal: 12,
    marginVertical: 6,
    height: 40,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  searchIcon: {
    marginRight: 8,
  },
  clearButton: {
    padding: 4,
  },
  searchInput: {
    flex: 1,
    height: '100%',
    fontSize: 16,
    color: theme.colors.text,
    fontFamily: theme.fonts.regular.fontFamily,
    ...(Platform.OS === 'web' && {
      WebkitTapHighlightColor: 'transparent',
      WebkitAppearance: 'none',
    }),
  },
  conversationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
    width: '100%',
  },
  conversationTime: {
    fontSize: 12,
    color: theme.colors.placeholder,
  },
  conversationLastMessageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: 6,
  },
  conversationLastMessage: {
    fontSize: 14,
    color: theme.colors.placeholder,
    flex: 1,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  unreadMessage: {
    color: theme.colors.text,
    fontWeight: 'bold',
  },
  bookingStatusContainer: {
    backgroundColor: theme.colors.primary + '20',
    padding: 4,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginTop: 2,
  },
  bookingStatus: {
    fontSize: 12,
    color: theme.colors.primary,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  activeConversationText: {
    color: theme.colors.text,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  unreadBadge: {
    backgroundColor: theme.colors.error,
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
    marginLeft: 8,
    alignSelf: 'flex-start',
  },
  unreadBadgeText: {
    color: 'white',
    fontSize: 11,
    fontWeight: 'bold',
    fontFamily: theme.fonts.regular.fontFamily,
  },
  mobileHeader: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
    position: 'sticky',
    top: 0,
    zIndex: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 3,
    backgroundColor: theme.colors.surfaceContrast,
    marginTop: 0,
    paddingTop: 0,
  },
  mobileHeaderContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingVertical: 16,
    paddingHorizontal: 8,
    width: '100%',
    minHeight: 60,
  },
  mobileHeaderName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colors.text,
    textAlign: 'center',
    fontFamily: theme.fonts.header.fontFamily,
    flexWrap: 'wrap',
  },
  mobileHeaderNameContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingHorizontal: 30, // Add padding to prevent overlap with back button
  },
  backArrow: {
    position: 'absolute',
    left: 16,
    zIndex: 10,
    padding: 8,
  },
  editDraftButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.surface,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    marginLeft: 'auto',
    borderWidth: 1,
    borderColor: theme.colors.primary,
  },
  editDraftText: {
    marginLeft: 4,
    color: theme.colors.primary,
    fontSize: 14,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  mobileEditDraftButton: {
    marginRight: 10,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.surface,
    minWidth: 55,
    alignSelf: 'flex-start',
  },
  messageHeaderContent: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  headerDropdownMenu: {
    position: 'absolute',
    top: '100%',
    right: 16,
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 4,
    minWidth: 180,
    borderWidth: 1,
    borderColor: theme.colors.border,
    zIndex: 1000,
  },
  headerDropdownItem: {
    padding: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerDropdownText: {
    color: theme.colors.text,
    fontSize: 14,
    marginLeft: 8,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  createBookingContainer: {
    position: 'absolute',
    top: 8,
    left: 0,
    right: 0,
    paddingHorizontal: 16,
    alignItems: 'center',
    zIndex: 10,
    pointerEvents: 'box-none',
  },
  createBookingHangingButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.surface,
    paddingHorizontal: screenWidth <= 600 ? 12 : 16,
    paddingVertical: screenWidth <= 600 ? 8 : 10,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: theme.colors.primary,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    width: '50%',
    justifyContent: 'center',
  },
  createBookingHangingText: {
    marginLeft: 8,
    color: theme.colors.primary,
    fontSize: screenWidth <= 600 ? 14 : 16,
    fontWeight: '500',
    fontFamily: theme.fonts.regular.fontFamily,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 12,
    color: theme.colors.placeholder,
    fontSize: 16,
    fontFamily: theme.fonts.regular.fontFamily,
  },
  emptyText: {
    padding: 16,
    color: theme.colors.placeholder,
    fontSize: 16,
    fontFamily: theme.fonts.regular.fontFamily,
    textAlign: 'center',
  },
  loadingMore: {
    padding: 16,
  },
  mobileMessageView: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginTop: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  mobileContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
      // Image handling styles for MessageInput
    selectedImagesWrapper: {
      width: '100%',
      marginBottom: 8,
      marginTop: 4,
      borderBottomWidth: 1,
      borderBottomColor: '#ECECEC',
      paddingBottom: 8,
    },
    selectedImagesScrollView: {
      width: '100%',
      maxHeight: 100,
    },
    selectedImagesContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 4,
    },
    selectedImageContainer: {
      position: 'relative',
      marginRight: 8,
      borderRadius: 8,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: '#ECECEC',
    },
    selectedImagePreview: {
      width: 80,
      height: 80,
      borderRadius: 8,
    },
    removeImageButton: {
      position: 'absolute',
      top: 4,
      right: 4,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      borderRadius: 12,
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
    },
    uploadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      alignItems: 'center',
      justifyContent: 'center',
    },
  // Styles for message images in MessageList
  messageImage: {
    width: 250,
    height: 250,
    borderRadius: 8,
    // marginVertical: 4,
    resizeMode: 'cover',
  },
  messageImagesContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 8,
  },
}); 